import type { RootState } from 'Store/index';
import { getSoftDeployAccessFromState } from 'App/components/hooks/featureHelper';
import { hasAiWorkspaceLicence } from 'App/helpers/navSections';

type AccountSelf = RootState['App']['accountSelf'];

export { hasAiWorkspaceLicence };

/**
 * The V2 prospecting workspace: the AI licence and `PROSPECTING_AGENT_V2` (WEB-10482).
 *
 * A pure function of `accountSelf`, so there is one statement of the rule (WEB-13133): the routes'
 * hooks feed it from `useSelector` and re-render when the account changes, and the admin sidebar,
 * a class component that cannot call a hook, feeds it the account it reads synchronously.
 */
export const hasProspectingWorkspaceAccess = (accountSelf: AccountSelf) =>
	hasAiWorkspaceLicence(accountSelf) && getSoftDeployAccessFromState(accountSelf, 'PROSPECTING_AGENT_V2');
